import React, { useContext, useEffect, useState } from 'react';
import { internalApi as api } from 'api';
import AuthContext from './AuthContext';

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isSignedIn, setIsSignedIn] = useState<boolean>(false);

  useEffect(() => {
    const validateToken = () => {
      api
        .get('/me')
        .then(({ data }) => {
          setIsSignedIn(data.status);
        })
        .catch(() => {
          setIsSignedIn(false);
        });
    };
    validateToken();
  }, []);

  return (
    <AuthContext.Provider value={{ signedIn: isSignedIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  if (!AuthContext) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return useContext(AuthContext);
};

export default AuthProvider;
